/**
 *
 * TaskCard
 *
 */

import React from "react"
import iconoCalendar from "images/calendar.svg"
import iconCheck from "images/check.svg"
import { CSSTransition } from "react-transition-group"
import { Tooltip } from "antd"
import "./index.less"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

class TaskCard extends React.Component {
  state = { visible: true }

  updateTaskStatus = async (id, done = 1) => {
    done = 1
    let url = `tasks/${id.id_task}/done`
    if (!id.id_task || (id.id_task && id.id_task_schedule)) {
      url = `tasks-schedules/${id.id_task_schedule}/done`
    }
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: url,
        data: { done : done },
      })
      returnMessage(result)
      this.setState({ visible: false })
    } catch (error) {
      returnMessage(error)
    }
  }

  render() {
    const { props } = this
    return (
      <CSSTransition
        in={this.state.visible}
        timeout={300}
        classNames="zoom"
        unmountOnExit
        onExited={() => this.props.reload()}>
        <div className="TaskCardComponent">
          <div
            className="TaskCardComponent-border"
            style={{ background: props.status }}
          />
          <div className="TaskCardComponent-content">
            <div>
              <Tooltip
                placement="bottomLeft"
                overlayClassName="taskDoneArrow"
                title={
                  props.data.done
                    ? "Marcar tarea como no completada"
                    : "Marcar tarea como completada"
                }>
                <div
                  className={`TaskCardComponent-content-check ${
                    props.data.done ? "complete" : ""
                  } ${
                    props.data.next ? "TaskCardComponent-content-shadow" : ""
                  }`}
                  onClick={() => {
                    this.updateTaskStatus(props.data, !props.data.done)
                  }}
                  style={{ cursor: "pointer", width: 20, height: 20 }}
                />
              </Tooltip>
            </div>
            <div>
              <h4>{props.data.name}</h4>
              <p>
                <img src={iconoCalendar} /> {props.data.date_format || ""}
              </p>
            </div>
          </div>
        </div>
      </CSSTransition>
    )
  }
}

TaskCard.defaultProps = { reload: () => {} }

export default TaskCard
